import {Modal} from '@carbon/react';
import Spinner from '../../../components/spinner';

interface LoadingModalProps {
    open: boolean;
    message?: string;
}

const LoadingModal = ({open, message = 'Processing your request...'}: LoadingModalProps) => {
    return (
        <Modal open={open} passiveModal preventCloseOnClickOutside size='sm'>
            <div className='w-full p-2 flex space-x-8 items-center'>
                <Spinner />
                <div>
                    <p><strong>{message}</strong></p>
                </div>
            </div>
        </Modal>
    );
};

export default LoadingModal;
